/**
 * Selectors
 */
export const MANAGER_ACCOUNT_REGISTRATION_PAGE_ID =
  'manager-account-registration';

/**
 * Translation keys
 */
export const MANAGER_ACCOUNT_REGISTRATION_TITLE_TRANSLATION_KEY =
  'manager_account_registration_title';
export const MANAGER_ACCOUNT_NAME_LABEL_TRANSLATION_KEY =
  'manager_account_name_label';
export const MANAGER_ACCOUNT_NAME_REQUIRED_TRANSLATION_KEY =
  'manager_account_name_required';
export const MANAGER_ACCOUNT_NAME_MAX_LENGTH_TRANSLATION_KEY =
  'manager_account_name_max_length';
export const MANAGER_ACCOUNT_NAME_BLANK_TRANSLATION_KEY =
  'manager_account_name_blank';
export const MANAGER_ACCOUNT_TYPE_LABEL_TRANSLATION_KEY =
  'manager_account_type_label';
export const MANAGER_ACCOUNT_TYPE_PLACEHOLDER_TRANSLATION_KEY =
  'manager_account_type_placeholder';
export const MANAGER_ACCOUNT_TYPE_OWNER_TRANSLATION_KEY =
  'manager_account_type_owner';
export const MANAGER_ACCOUNT_TYPE_AGENCY_TRANSLATION_KEY =
  'manager_account_type_agency';
export const MANAGER_ACCOUNT_SUBMIT_TRANSLATION_KEY = 'manager_account_submit';
export const MANAGER_ACCOUNT_SUBMITTING_TRANSLATION_KEY =
  'manager_account_submitting';
export const MANAGER_ACCOUNT_CREATION_ERROR_TRANSLATION_KEY =
  'manager_account_creation_error';
